import React from 'react'
import { icons } from '../utilits/icons';
import { optionElips, optionElips2 } from '../utilits/statisticTools';
import Chart from 'react-apexcharts'

export default function Range() {
  return (
    <div className='range'>
       <span>{icons.range}</span>
        <h3>Range</h3>
        <Chart options={optionElips2.options} series={optionElips2.series} type="radialBar" />
    </div>
  )
}
